export default __webpack_public_path__ + "static/media/1-small.b0b46423.png";